
import { NoseurObject } from "@rivtn/noseur";
import { ICurrency } from "./CurrencyService";
import { Actor, SanitizedResponse } from "../BaseService";
import { PloutousBaseService } from "./PloutousBaseService";

export interface ICountry {
    name: string;
    code: string;
    status: string;
    created_by: Actor;
    updated_by: Actor;
    dial_code: string;
    short_name: string;
    created_at: string;
    updated_at: string;
    currency_id: string;
    external_id: string;
    currency: ICurrency;
    icon_png_base64: string;
}

export class CountryService extends PloutousBaseService {

    protected static instance: CountryService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!CountryService.instance) CountryService.instance = new CountryService();
        return CountryService.instance;
    }

    queryCountries(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/api/v1/country", { query: this.normalizeParams(params) }));
    }

    getCountryByCode(code: string): Promise<SanitizedResponse<ICountry>> {
        return this.report(this.transport.get(`/api/v1/country/code/${code}`, { cache: true, key: `LANGUAGE_${code}` }));
    }
    
    createCountry(payload: any): Promise<SanitizedResponse<ICountry>> {
        return this.report(this.transport.post(`/api/v1/country`, payload));
    }

    updateCountry(payload: Partial<ICountry>): Promise<SanitizedResponse<ICountry>> {
        const id = payload.external_id; delete payload.external_id;
        return this.report(this.transport.patch(`/api/v1/country/${id}`, payload));
    }

    deleteCountry(id: string): Promise<SanitizedResponse<ICountry>> {
        return this.report(this.transport.delete(`/api/v1/country/${id}`));
    }

}
